<template>
    <svg
        fill="none"
        height="16"
        viewBox="0 0 15 16"
        width="15"
        xmlns="http://www.w3.org/2000/svg">
        <mask
            id="mask0_1241_1988"
            height="16"
            maskUnits="userSpaceOnUse"
            style="mask-type: luminance"
            width="15"
            x="0"
            y="0">
            <path
                d="M0 0.599977H15V15.6H0V0.599977Z"
                fill="white" />
        </mask>
        <g mask="url(#mask0_1241_1988)">
            <path
                d="M8.37891 8.1C5.14699 8.1 2.16316 9.95529 0.717803 12.846L0.439453 13.4877V12.5238C0.439453 8.15514 4.01024 4.58438 8.37891 4.58438V1.52286L14.2969 6.34219L8.37891 11.1762V8.1Z"
                stroke="currentColor"
                stroke-miterlimit="10" />
        </g>
    </svg>
</template>

<script setup lang="ts"></script>

<style scoped></style>
